<template>
  <div id="user-avatar">
    <v-avatar
      :color="
        avatarURL ? '' : $vuetify.theme.dark ? 'dark_backgroundLighterBlack' : 'darkBackgroundGrey'
      "
      :size="size"
      class="user-avatar-avatar"
    >
      <img v-if="avatarURL" :src="avatarURL" />
      <span v-else class="user-avatar-initials darkTextGrey--text">{{ avatarInitials }}</span>
    </v-avatar>
  </div>
</template>

<script>
import userMixin from '@/views/components/core/userMixin.js'

export default {
  mixins: [userMixin],
  props: {
    size: {
      type: String,
      default: '26',
    },
  },
  computed: {
    avatarInitials() {
      const split = this.displayName.toUpperCase().split(' ')
      let initials = split[0][0]
      if (split.length > 1 && !!split[1]) initials = initials + split[1][0]
      return initials
    },
  },
}
</script>

<style lang="scss">
#user-avatar {
  .user-avatar-avatar {
    margin-bottom: 2px;
  }
  .user-avatar-initials {
    font-size: 13px;
    font-weight: 300;
  }
}
</style>
